<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Imagen</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Precio</th>
                <th :class="StyleTh">Cantidad</th>
                <th :class="StyleTh">Descripcion</th>
                <th :class="StyleTh">Descripcion en Inglés</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td>
                        <span v-if="lista.Imagen">
                            <img alt="Imagen" :src="RutaFile+lista.UrlImagen+lista.Imagen" width="90px" height="90px">
                        </span>
                        <span v-else>
                            <img alt="Imagen" src="@/assets/style/image/sin_imagen_180.jpg" width="90px" height="90px">
                        </span>
                    </td>
                    <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">$ {{lista.Precio}}</p></td>
                    <td><p :class="StyleTd">{{lista.Cantidad}}</p></td>
                    <td><p :class="StyleTd">{{$limitCharacters(lista.Descripcion,90)}}</p></td>
                    <td><p :class="StyleTd">{{$limitCharacters(lista.DescripcionIng,90)}}</p></td>
                    
                    <td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdPaquete" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <!-- Remover v-show en caso de agregar más botones -->
                                <CMoreButtonsL v-show="segurity.ViewSection">
							        <template slot="bodyBtnsL">
                                        <template v-if="segurity.ViewSection">
                                            <li @click="IrAlDetalle(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-box-ballot"></i> Ver Elementos del Paquete
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/catalogos/paquetehotel/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPaquetehotel';

export default {
    name: 'ListaPaquetehotel',
    props:['pObjEnviado'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Paquetes',
                IsModal: true,
                ShowLoader: true,
                BtnReturnShow: true,
                TitleFirst:'',
                EmitSeccion: EmitEjecuta,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario de Paquetes",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjAgente: {},
            RutaFile: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("paqueteshotel",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdAgente: this.ObjAgente.IdAgente,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.RutaFile           = res.data.RutaFile;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('paqueteshotel/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'hotelEmpresa',params:{}});
        },
        IrAlDetalle(item){
            this.$router.push({name: 'elementopaquete',params:{pObjEnviado:item}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objAgente',JSON.stringify(this.pObjEnviado));
        }

        this.ObjAgente = JSON.parse(sessionStorage.getItem('objAgente'));
        this.ConfigList.TitleFirst=this.ObjAgente.NombreComercial;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
